export const APP_NAME = 'filtrd.io';
export const APP_DESCRIPTION = 'Reclaim your attention while staying informed.';
